import React, { useRef, useState, useEffect } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
  Toolbar,
  Sort,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { DataManager } from "@syncfusion/ej2-data";
import LoadingIndicator from "../pages/LoadingIndicator";

const DataGrid = ({
  loading,
  data,
  cols,
  name = "",
  handleRowSelected,
  handleDoubleClick,
  handleRefresh,
  persistant = true,
}) => {
  const grid = useRef(null);
  const [selectedId, setSelectedId] = useState(0);

  const goToRowById = (id) => {
    if (!grid.current || name !== "part") return;
    const gridd = grid.current;
    const pageSize = gridd.pageSettings.pageSize;

    // 1️⃣ Get FULL processed data (sorted + filtered)
    const dm = new DataManager(gridd.dataSource);
    const query = gridd.getDataModule().generateQuery();
    query.queries = query.queries.filter(
      (q) => !["onPage", "onSkip", "onTake"].includes(q.fn),
    );

    dm.executeQuery(query).then((e) => {
      const result = e.result;

      // 2️⃣ Find index in processed data
      const rowIndex = result.findIndex((d) => d.part_id === id);
      if (rowIndex === -1) return;

      // 3️⃣ Calculate page
      const page = Math.floor(rowIndex / pageSize) + 1;

      // 4️⃣ Navigate

      setTimeout(() => {
        gridd.goToPage(page);
      }, 0);
      // 5️⃣ Select row after render
      setTimeout(() => {
        const indexInPage = rowIndex % pageSize;
        try {
          gridd.selectRow(indexInPage);
        } catch (err) {
          // console.log(err);
        }
      }, 1000);
    });
  };

  const handleToolbarClick = async (args) => {
    if (args.item.id === "refreshGrid") {
      grid.current?.showSpinner();
      try {
        await handleRefresh();
      } finally {
        grid.current?.hideSpinner();
      }
    }
  };

  useEffect(() => {
    if (name === "part")
      if (selectedId) localStorage.setItem("partSelectedId", selectedId);
  }, [selectedId]);

  useEffect(() => {
    if (name === "part") if (selectedId) goToRowById(selectedId);
  }, [data]);

  useEffect(() => {
    if (name === "part") {
      setSelectedId(Number(localStorage.getItem("partSelectedId")) || 0);
      if ((data.length && Number(localStorage.getItem("partSelectedId"))) || 0)
        goToRowById(Number(localStorage.getItem("partSelectedId")) || 0);
    }
  }, []);

  const created = () => {
    if (grid.current) {
      const searchInput = document.getElementById(
        grid.current.element.id + "_searchbar",
      );
      searchInput.addEventListener("keyup", (args) => {
        grid.current.search(args.target.value);
      });
    }
  };

  return (
    <div className="m-0 p-0">
      {loading ? (
        <LoadingIndicator />
      ) : (
        <GridComponent
          className="custom-grid"
          ref={grid}
          dataSource={data}
          allowPaging={true}
          pageSettings={{ pageSize: 16, pageSizes: [16, 48, 100, "All"] }}
          enablePersistence={persistant}
          height="calc(62vh - 60px)"
          allowSorting
          allowResizing
          toolbar={[
            "Search",
            {
              text: "",
              tooltipText: "Refresh",
              prefixIcon: "e-refresh",
              id: "refreshGrid",
            },
          ]}
          toolbarClick={handleToolbarClick}
          // rowSelected={handleRowSelected}
          rowSelected={(args) => {
            if (name === "part") setSelectedId(args.data.part_id); // or your unique key
            handleRowSelected(args);
          }}
          recordDoubleClick={handleDoubleClick}
          rowHeight={36}
          created={created}
        >
          <ColumnsDirective>
            {cols.map((item, index) => (
              <ColumnDirective key={index} {...item} />
            ))}
          </ColumnsDirective>
          <Inject services={[Resize, Sort, Page, Toolbar]} />
        </GridComponent>
      )}
    </div>
  );
};

export default DataGrid;
